import { TFunction } from 'react-i18next';
import * as Yup from 'yup';

export const UploadInvoiceStepSchema = (t: TFunction) =>
  Yup.object().shape({
    buyerRef: Yup.string().required(t('common:requiredField')),
    number: Yup.string().required(t('common:requiredField')),
    amount: Yup.number().required(t('common:requiredField')),
    date: Yup.date()
      .required(t('common:requiredField'))
      .test(
        'max-30-days',
        t('servicing:newFinanceRequest.manual.uploadInvoiceStep.fields.invoiceDate.maxDateError'),
        function (value) {
          if (!value) return false;
          const today = new Date();
          const invoiceDate = new Date(value);
          const diffTime = today.getTime() - invoiceDate.getTime();
          const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
          return diffDays <= 30;
        }
      ),
    dueDate: Yup.date().required(t('common:requiredField')),
    purchaseOrder: Yup.string().optional(),
    description: Yup.string()
      .max(50, t('common:maxLength', { max: 50 }))
      .optional(),
  });
